module.exports = __webpack_public_path__ + "media/images/writer/user_extension_notification_mailer/background_music-80701c5f6f0ae7aae0871532d83ccf53.png";